import { URL_CONSTANTS } from '../../../constants/urlConstants';
import apiService from '../../../services/api.service';
import { getQueryResult } from '../../Analytics/Widget/service/widget.service';

export const allStore = async searchValue => {
  try {
    const storesRequest = await apiService.get(
      `/stores?searchString=${searchValue}`
    );
    return storesRequest;
  } catch (err) {
    console.error(err);
  }
};

export const getCustomerList = async searchValue => {
  try {
    let endpoint = '/customers?offset=0&limit=10';

    if (searchValue) {
      endpoint += `&searchString=${searchValue}`;
    }
    const response = await apiService.get(endpoint);
    return response;
  } catch (error) {
    console.error(error);
    return [];
  }
};

export const getWorkroomOptions = async value => {
  try {
    const response = await apiService.get(
      `/master/get-Workroom/list?search=${value}`
    );
    if (response && response?.data) {
      return response?.data;
    }
    return [];
  } catch (error) {
    console.error(error);
    return [];
  }
};

export const getDefaultFilterValuesById = async value => {
  try {
    const response = await apiService.get(
      apiService.formatUrl(
        URL_CONSTANTS.GLOBAL_FILTERS.getDefaultFiltersById,
        value
      )
    );
    if (response && response?.data) {
      return response?.data;
    }
    return [];
  } catch (error) {
    console.error(error);
    return [];
  }
};

export const getCompanyListForFilter = async () => {
  try {
    const response = await getQueryResult({
      limit: 1000,
      dimensions: ['Companies.company_id', 'Companies.company_name'],
      order: { 'Companies.company_name': 'asc' },
    });
    return (response?.data || []).map(item => ({
      company_id: item['Companies.company_id'],
      company_name: item['Companies.company_name'],
    }));
  } catch (error) {
    console.error(error);
    return [];
  }
};

export const getTeamListForFilter = async () => {
  try {
    const teamListResponse = await apiService.get(`/system/team`);
    return teamListResponse ?? [];
  } catch (error) {
    console.error(error);
    return [];
  }
};
